import AsyncStorage from '@react-native-async-storage/async-storage';

import { supabase } from '@/lib/supabase';

const PENDING_AGREEMENT_KEY = 'pending_invite_agreement_id';
const PENDING_CODE_KEY = 'pending_invite_agreement_code';

// Κρατά προσωρινά το id της συμφωνίας από ένα link πρόσκλησης σε AsyncStorage,
// ώστε μετά την εγγραφή/onboarding να μεταβεί αυτόματα ο χρήστης σε αυτήν.
//
// Μαζί κρατάμε και τον 6ψήφιο κωδικό πρόσκλησης (αν τον έχουμε): είναι η
// απόδειξη ότι ο συγκεκριμένος άνθρωπος είναι όντως ο παραλήπτης, ώστε να
// δηλωθεί αντισυμβαλλόμενος ΑΝΕΞΑΡΤΗΤΑ από το email με το οποίο εγγράφηκε.
// Χωρίς αυτό, η σύνδεση γινόταν μόνο μέσω ταιριάσματος email και ο χρήστης
// έμενε «θεατής» χωρίς δυνατότητα υπογραφής.

export async function setPendingInviteAgreement(id: string, code?: string | null): Promise<void> {
  await AsyncStorage.setItem(PENDING_AGREEMENT_KEY, id);
  if (code) {
    await AsyncStorage.setItem(PENDING_CODE_KEY, code);
  }
}

/** Επιστρέφει & καθαρίζει το pending id (καταναλώνεται μία φορά). */
export async function consumePendingInviteAgreement(): Promise<string | null> {
  const value = await AsyncStorage.getItem(PENDING_AGREEMENT_KEY);
  if (value) await AsyncStorage.removeItem(PENDING_AGREEMENT_KEY);
  return value;
}

/** Επιστρέφει & καθαρίζει τον pending κωδικό πρόσκλησης. */
async function consumePendingInviteCode(): Promise<string | null> {
  const value = await AsyncStorage.getItem(PENDING_CODE_KEY);
  if (value) await AsyncStorage.removeItem(PENDING_CODE_KEY);
  return value;
}

/**
 * Δηλώνει τον συνδεδεμένο χρήστη ως αντισυμβαλλόμενο, χρησιμοποιώντας τον
 * κωδικό πρόσκλησης ως απόδειξη. Καλείται μετά την εγγραφή/σύνδεση, μόλις
 * υπάρχει session. Είναι idempotent και σιωπηλή: αν δεν υπάρχει κωδικός ή
 * αν η συμφωνία έχει ήδη αντισυμβαλλόμενο, απλώς δεν κάνει τίποτα — ο
 * χρήστης οδηγείται κανονικά στη συμφωνία και βλέπει εκεί την κατάστασή της.
 */
export async function claimPendingInviteAgreement(agreementId: string): Promise<void> {
  const code = await consumePendingInviteCode();
  if (!code) return;
  try {
    await supabase.rpc('claim_agreement_with_invite_code' as never, {
      p_agreement_id: agreementId,
      p_code: code,
    } as never);
  } catch {
    // Δεν μπλοκάρουμε την πλοήγηση — η οθόνη της συμφωνίας δείχνει ούτως ή
    // άλλως τι ισχύει (π.χ. ότι δεν είναι μέρος της).
  }
}
